var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantingGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "planting"
  }, /*#__PURE__*/React.createElement("g", {
    id: "planting_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7532 15.4091C29.8461 14.0621 29.8625 10.8472 27.7899 8.22842C25.7172 5.60962 22.3404 4.57859 20.2475 5.92556C18.1546 7.27253 18.1381 10.4874 20.2108 13.1062C22.2834 15.725 25.6602 16.756 27.7532 15.4091Z",
    fill: "#868CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9571 35.6076C35.4244 33.4379 34.5439 30.0641 31.9905 28.072C29.437 26.08 26.1776 26.224 24.7102 28.3937C23.2429 30.5634 24.1234 33.9372 26.6768 35.9293C29.2303 37.9213 32.4897 37.7773 33.9571 35.6076Z",
    fill: "#868CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5441 18.8951C39.4715 21.5139 39.4879 24.7288 41.5808 26.0757C43.6737 27.4227 47.0506 26.3917 49.1232 23.7729C51.1958 21.1541 51.1794 17.9392 49.0865 16.5922C46.9936 15.2453 43.6167 16.2763 41.5441 18.8951Z",
    fill: "#868CA2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00032 34.6673C5.05481 34.6673 2.66699 37.0551 2.66699 40.0007V61.334H61.3337V40.0007C61.3337 37.0551 58.9458 34.6673 56.0003 34.6673H50.0824C47.613 34.6673 45.7197 36.3046 44.8481 38.1085C43.6518 40.5843 40.3726 45.334 32.0003 45.334C23.628 45.334 20.3488 40.5843 19.1525 38.1085C18.2809 36.3046 16.3877 34.6673 13.9183 34.6673H8.00032ZM8.00033 56.0007V40.0007H13.9183C13.9183 40.0007 13.9277 40.0006 13.9469 40.0071C13.9682 40.0143 14.0052 40.0306 14.0536 40.0648C14.1571 40.1381 14.2712 40.2648 14.3504 40.4288C16.1253 44.102 20.9518 50.6673 32.0003 50.6673C43.0488 50.6673 47.8754 44.102 49.6502 40.4288C49.7295 40.2648 49.8436 40.1381 49.947 40.0648C49.9954 40.0306 50.0324 40.0143 50.0537 40.0071C50.0729 40.0006 50.0824 40.0007 50.0824 40.0007H56.0003V56.0007H8.00033Z",
    fill: "#868CA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantingGray);
export default __webpack_public_path__ + "static/media/planting-gray.f5edc670b0094e5e36315593490c266d.svg";
export { ForwardRef as ReactComponent };